import React, { Component } from 'react';
import { connect } from 'react-redux';

import Modal from '../../../../components/Modal';
import LoadMask from '../../../../components/LoadMask';
import LuftCompanyForm from './LuftCompanyForm';

import { getAddCompanyUI } from '../../../../redux/selectors';
import { fetchCompanies, fetchAddCompany, addCompanyClear } from '../../../../redux/admin-companies';

class AddCompanyModal extends Component {
  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch(addCompanyClear());
  }

    _submit = ({
      corporateName, cnpjList, luftBranch, logoFile, divisions,
    }) => {
      const { dispatch, onDismiss } = this.props;

      dispatch(fetchAddCompany(corporateName, cnpjList, luftBranch, logoFile, divisions)).then(
        () => {
          onDismiss();
          dispatch(fetchCompanies());
        },
        // reject
        () => {},
      );
    }

    render() {
      const { ui, onDismiss } = this.props;

      return (
        <Modal
          title="Nova empresa"
          size="small"
          onBackdropClick={onDismiss}
        >
          <LuftCompanyForm
            errorMessage={ui.error}
            onDismiss={onDismiss}
            onSubmit={this._submit}
          />
          {
                    ui.isFetching &&
                    <LoadMask text="Salvando..." />
                }
        </Modal>
      );
    }
}

function mapStateToProps(state) {
  return {
    ui: getAddCompanyUI(state),
  };
}

export default connect(mapStateToProps)(AddCompanyModal);

